import { createContext } from 'react';

/** The id the payment form carries, so a button outside it can submit it with the `form` attribute. */
export const STRIPE_CHECKOUT_FORM_ID = 'stripe-checkout-form';

export interface StripeCheckoutSubmitState {
  label: string;
  disabled: boolean;
  /** the form is mid-submit, so the button shows a spinner instead of its label */
  loading: boolean;
  /** paypal renders its own button inside the form, so nothing else should submit */
  hidden: boolean;
}

/**
 * Lets the payment form publish what its submit button would say and whether it can be pressed,
 * so the checkout page can draw that button under the order summary on desktop.
 */
const StripeCheckoutSubmitContext = createContext<((state: StripeCheckoutSubmitState) => void) | undefined>(undefined);

export default StripeCheckoutSubmitContext;
